<template>
        <div  class="bankCardJD">
            <!---图标-->
            <div class="title">请输入验证码</div>
            <div class="mobile">{{mobile}}</div>
            <div class="codebox">
                <md-codebox @submit="onSubmit" :value="code"></md-codebox>
            </div>
            <div class="codebox">
                <div class="send-btn" v-if="!timer" @click="sendCode">重新发送</div>
                <div class="send-text" v-if="timer">{{time}}s后重发</div>
            </div>
            <mu-button style="margin-top:1.6rem" :disable="submiting" color="primary" text="下一步" @click="submitJD"></mu-button>
            <div class="tip">温馨提示：服务由第三方提供</div>
        </div>
        <!--二维码弹出-->
</template>

<style lang="less" rel="stylesheet/less" scoped>
  .bankCardJD {
    padding: 2.8rem;

    .title {
      text-align: center;
      font-size: 3rem;
      line-height: 1;
      color: #222;

    }

    .mobile {
      text-align: center;
      margin-top: 2rem;
      font-size: 3rem;
      line-height: 1;
      color: #888;
    }

    .send-btn {
      font-size: 1.5rem;
      text-align: center;
      color: #488bf4;
      padding-left: 1rem;
      padding-right: 1rem;
    }

    .send-text {
      font-size: 1.5rem;
      text-align: center;
    }

    .tip {
      margin-top: 2rem;
      text-align: center;
    }

    .codebox {
      margin-top: 2rem;
    }
  }

</style>

<script  >
    import CodeBox from './codebox.vue';
    import webapi from '../../request/webapi';
    export default {
        name: 'bankCardJD',
        components: {
            [CodeBox.name]: CodeBox
        },
        data: function () {
            return {
                code: '',
                time: 59,
                timer: null,
                mobile: '',
                submiting: false,
                uniqueId: this.$route.query.uniqueId
            };
        },
        mounted() {
            this.mobile = this.$route.query.mobile;
            this.startTimer();
        },
        methods: {
            onSubmit (val) {
                this.code = val;
            },
            startTimer() {
                if (this.timer) {
                  this.stopTimer();
                }
                this.timer = window.setInterval(() => {
                    this.time--;
                    if(this.time === 0) {
                        this.stopTimer();
                        this.time = 59
                    }
                    return false;
                }, 1000);
            },
            stopTimer() {
                if (this.timer) {
                    window.clearInterval(this.timer);
                    this.timer = null;
                }
            },
            async sendCode() {
                // alert('重新获取验证码');
                this.code = '';
                this.startTimer();
                let result = await webapi.bank.resendVerificationCode({
                    uniqueId: this.$route.query.uniqueId
                });
                if(result.statusCode !== 200){
                    this.$showAlert({ text: '短信发送失败!' });
                } else {
                    this.uniqueId = result.data.uniqueid;
                }
            },
            async submitJD() {
                if(this.submiting) {
                    return;
                }
                if(!this.code || this.code === '' || this.code.length !== 6) {
                    return this.$showAlert({ text: '请输入短信验证码' });
                }
                this.submiting = true;
                try {
                    let result = await webapi.bank.agreementSignConfirm({
                        uniqueId: this.uniqueId,
                        verifyValue: this.code
                    });
                    if (result.statusCode !== 200) {
                        this.$showAlert({text: result.message});
                        this.code = '';
                        this.submiting = false;
                    } else {
                        this.$store.commit(
                            'updateBankId',
                            result.data
                        );
                        this.submiting = false;
                        this.$router.go(-2);
                    }
                }catch (e) {
                    this.submiting = false;
                }
            }
        },
        beforeDestroy() {
            this.stopTimer();
        }
    };
</script>
